import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AuthenticationManager from "../../services/StorageJWT";
import PopupBox from "../../components/PopupBox";
import { Button, Spinner } from "react-bootstrap";
import MasterPage from "../../layouts/MasterPage";
import assistAPI from "../../api/assistAPI";

const Assist = () => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, forceupdate] = useState(0);
  const [assistsFields, setAssistsFields] = useState([
    {
      name: "",
      mobile: "",
      code: (Math.random() + 1).toString(36).substring(5),
    },
  ]);
  const [errorText, setErrorText] = useState("");
  const [show, setShow] = useState(false);
  var _auth = new AuthenticationManager();
  let statePrev = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    assistAPI
      .assists(_auth._token)
      .then((res) => {
        if (res.length !== 0) setAssistsFields(res);
      })
      .catch((e) => console.log(e));
  }, []);
  const onSubmit = () => {
    let validation = true;
    assistsFields.map((af) => {
      if ((!af.name && af.mobile) || (af.name && !af.mobile)) {
        validation = false;
      }
      if (af.mobile && af.mobile.length != 11) validation = false;
    });
    if (validation == false) {
      setShow(true);
      setErrorText("لطفا نام و شماره همراه را درست وارد نمایید!");
      return;
    }
    setLoading(true);
    assistAPI
      .addAssist(assistsFields, _auth._token)
      .then((res) => {
        _auth.updatePoint(res.point);
        console.log(_auth._user.user);
        if (statePrev?.state?.prePage === "menu") window.history.back();
        else if (statePrev?.state?.prePage === "code") navigate("/menu/games");
        else if (_auth._user.user.active_game_id == 2) navigate("/two");
        else navigate("/one");
      })
      .catch((e) => {
        if (e?.response?.status == 422) {
          setShow(true);
          setErrorText(e?.response?.data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleFormChange = (index, event) => {
    let data = [...assistsFields];
    data[index][event.target.name] = event.target.value;
    setAssistsFields(data);
    forceupdate(Math.random());
  };
  const addAssist = () => {
    if (assistsFields.length > 3) {
      setShow(true);
      setErrorText("امکان درح بیشتر از ۴ همبازی را ندارید");
      return;
    }
    let newfield = {
      name: "",
      mobile: "",
      code: (Math.random() + 1).toString(36).substring(5),
    };
    setAssistsFields([...assistsFields, newfield]);
  };
  return (
    <MasterPage>
      <div className="structure-page-2 structure-page-6 login p-4 body ">
        <div>
          <h6>ثبت مشخصات همبازی</h6>
          <p className="text-center mt-4">
            به ازای ثبت مشخصات هر همبازی، 200 امتیاز دریافت خواهید کرد. با بالا
            بردن امتیاز اولیه خود، می توانید در حین بازی راهنمایی های بیشتری را
            مشاهده کنید.
          </p>
        </div>
        <div className="text-center w-100 pb-2">
          {assistsFields.map((input, index) => {
            return (
              <div key={index}>
                <div className="form-group mt-3  w-100">
                  <label htmlFor="name" className="w-100">
                    {index + 1}- نام و نام خانوادگی{" "}
                    <span className="text-danger">*</span>
                    <input
                      onChange={(event) => handleFormChange(index, event)}
                      type="text"
                      name="name"
                      value={input.name}
                      className={`form-control w-100 `}
                      placeholder="مثال: آرین جعفری"
                    />
                  </label>
                </div>
                <div className="form-group ">
                  <label htmlFor="name" className="w-100">
                    شماره همراه <span className="text-danger">*</span>
                    <input
                      onChange={(event) => handleFormChange(index, event)}
                      value={input.mobile}
                      type="number"
                      name="mobile"
                      className="form-control w-100"
                      placeholder="مثال: ۰۹۰۱۶۶۶۱۱۲۲ کنید"
                    />
                  </label>
                </div>
              </div>
            );
          })}

          <Button
            onClick={addAssist}
            className="btn-submit w-auto ps-4 pe-4 d-flex align-items-center mt-2 ms-2"
          >
            +
          </Button>
          <PopupBox show={show} setShow={setShow} text={errorText} />
        </div>
        <div>
          <Button
            variant="dark"
            className="btn btn-submit d-flex justify-content-center  mb-2"
            onClick={onSubmit}
          >
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                className="p-2"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <span className="mt-1">
                {" "}
                {statePrev?.state?.prePage == "properties" ? "ادامه" : "ثبت"}
              </span>
            )}
          </Button>
          {statePrev?.state?.prePage === "menu" ? (
            <button
              onClick={() => navigate("/menu/points", { replace: true })}
              className="btn btn-return pt-2 pb-2 w-100"
            >
              بازگشت
            </button>
          ) : null}
        </div>
      </div>
    </MasterPage>
  );
};

export default Assist;
